/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState, useRef } from "react";
import { Layout, Card, Table, Button, Space, Input } from "antd";
import dayjs from "dayjs";

import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";

import { getAPI } from "../../../utils/common";
import { KITCHEN_STOCK_REPORT } from "../../../constants/api";
import LS_SERVICE from "../../../utils/localStorage";
import { PROJECT_NAME } from "../../../constants/constent";

function KitchenStockReport() {
  const { Content } = Layout;
  const { Search } = Input;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [printMode, setPrintMode] = useState(false);
  const [searchText, setSearchText] = useState("");

  const { company_name } = LS_SERVICE.get("setting") || {};
  const printRef = useRef();

  useLayoutEffect(() => {
    getAPI(
      KITCHEN_STOCK_REPORT,
      (res) => {
        if (res.status) {
          const calculatedData = res.data.map((e) => ({
            ...e,
            current_stock: `${Number(e.current_stock)} ${e.unit}`,
            total: Number(e.rate) * Number(e.current_stock),
          }));

          setData(calculatedData);
        }

        setLoading(false);
      },
      () => setLoading(false),
    );
  }, []);

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  // Filter data
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase();

    return (
      item?.name?.toLowerCase().includes(search) ||
      item?.item_code?.toLowerCase().includes(search)
    );
  });

  const columns = [
    {
      title: "S.No",
      render: (_, __, i) => i + 1,
    },
    {
      title: "Item Code",
      dataIndex: "item_code",
    },
    {
      title: "Item Name",
      dataIndex: "name",
    },
    {
      title: "Current Stock",
      dataIndex: "current_stock",
    },
    {
      title: "Rate",
      dataIndex: "rate",
      render: (v) => `₹ ${v}`,
    },
    {
      title: "Total Value",
      dataIndex: "total",
      render: (v) => `₹ ${v}`,
    },
  ];

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title="Current Stock Report"
          extra={
            <Space>
              <Search
                placeholder="Search item..."
                allowClear
                onChange={(e) => setSearchText(e.target.value)}
                enterButton
                style={{ maxWidth: 400 }}
              />

              <Button
                type="primary"
                onClick={() => {
                  setPrintMode(true);

                  setTimeout(() => {
                    handlePrint();
                    setPrintMode(false);
                  }, 500);
                }}
              >
                Print Report
              </Button>
            </Space>
          }
        >
          <div ref={printRef}>
            {/* Print Header */}
            {printMode && (
              <div style={{ textAlign: "center", marginBottom: 20 }}>
                <h2>{company_name || PROJECT_NAME} Kitchen Stock Report</h2>
                <h3>Date: {dayjs().format("YYYY-MM-DD")}</h3>
              </div>
            )}

            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              rowKey="id"
              pagination={
                printMode
                  ? false
                  : {
                      pageSize: 10,
                    }
              }
            />
          </div>
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default KitchenStockReport;
